import { UserRole } from './../models/users/user';
import { AuthService } from './../../core/services/auth/auth.service';
import { NgForm } from '@angular/forms';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { TimesheetApiService } from 'src/app/core/services/api/timesheet-api.service';
import { Service } from '../models/services/service';
import { Timesheet } from '../models/timesheet/timesheet';
import { ExpenseTypeEnum, TimesheetExpense } from '../models/timesheet/timesheetEntry';
import { LawyerLite } from '../models/lawyers/lawyer';
import { OperatorFunction, Observable, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap, switchMap, map } from 'rxjs/operators';
import { TimesheetSearchResults } from '../models/timesheet/timesheetSearchResults';
import { TimesheetSearchParams } from '../models/timesheet/timesheetSearchParams';

@Component({
  selector: 'app-file-expense-form',
  templateUrl: './file-expense-form.component.html',
  styleUrls: ['./file-expense-form.component.scss']
})
export class FileExpenseFormComponent implements OnInit {
  public expenseType = ExpenseTypeEnum;
  public timesheets: Timesheet[] = [];
  public services: Service[] = [];
  timesheetLoading;
  expenseTypeEnum = ExpenseTypeEnum;
  public params: TimesheetSearchParams = new TimesheetSearchParams();
  searching = false;
  searchFailed = false;
  @Input() expense: TimesheetExpense;
  @Input() selectedTimesheet: number;
  @Input() fileNum: string;
  @Output() close: EventEmitter<any> = new EventEmitter<any>();
  @Output() submitExpense: EventEmitter<TimesheetExpense> = new EventEmitter<TimesheetExpense>();



  constructor(
    private timesheetApi: TimesheetApiService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private authService: AuthService

  ) {
    this.expense = this.expense ? this.expense : new TimesheetExpense();
  }

  ngOnInit(): void {
    if (this.selectedTimesheet) {
      this.expense.timesheet = this.selectedTimesheet;
    }
  }

  onSubmit(f: NgForm) {
    this.spinner.show();
    const req = this.expense.id ?
      this.timesheetApi.updateTimesheetExpense(this.expense) :
      this.timesheetApi.createTimesheetExpense(this.expense);
    req.subscribe(
      r => {
        // this.toastr.success('Expense saved', 'Success!');
        // this.spinner.hide();
        // this.close.emit();
        // this.submitExpense.emit(r);
        location.reload();
      }
    )
  }

  loadTimesheets() {
    if (this.timesheets.length === 0) {
      this.timesheetLoading = true;
      this.timesheetApi.activeTimesheets().subscribe(
        r => {
          this.timesheets = r;
          this.timesheetLoading = false;
        }
      )
    }
  }

  getTypes() {
    const obj = Object.keys(ExpenseTypeEnum).filter(v => !Number(v)).map(x => {
      return { id: ExpenseTypeEnum[x], val: x }
    })
    return obj;
  }

  onClose() {
    this.close.emit();
  }

  get isAdmin() {
    return this.authService.user.role === UserRole.ADMIN;
  }

  get isLawyer() {
    return this.authService.user.role === UserRole.LAWYER;
  }
  
  get canEditAnyTimesheet() {
    return this.authService.user.canEditTimesheets;
  }

  search: OperatorFunction<string, readonly Timesheet[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      tap(term => {
        this.searching = true;
        this.params.search = term;
      }),
      switchMap(term => term === '' ? of(null) :
        this.timesheetApi.getTimesheets(this.params).pipe(
          map((response: TimesheetSearchResults) => {
            this.expense.timesheet = response.results[0]?.id;
          }),
          tap(() => this.searchFailed = false)
        )
      ),
      tap(() => this.searching = false)
    )

  formatter = (x: Timesheet) => x.caseNum;
}